export default "__VITE_ASSET__9BIRK$nX__"